import React from 'react'
import { Colors } from '@enums/Colors'
import styles from './RatingStars.module.scss'

interface RatingStarProps {
  rating: number
  total: number
  starColor?: Colors
  starBackgroundColor?: Colors
}

const RatingStars = ({
  rating,
  total,
  starColor = Colors.DefaultStarColor,
  starBackgroundColor = Colors.DefaultStarBgColor,
}: RatingStarProps) => {
  const getStarStyle = (starValue: number) => {
    if (starValue <= 0) {
      return { background: `${starBackgroundColor} text` }
    }
    if (starValue >= 1) {
      return { background: `${starColor} text` }
    }
    return {
      background: `linear-gradient(
        to right,
        ${starColor} 0%,
        ${starColor} ${starValue * 100}%,
        ${starBackgroundColor} ${starValue * 100}%,
        ${starBackgroundColor} 100%
      ) text`,
    }
  }
  return (
    <div className={styles.background}>
      {Array.from({ length: total }, (_, i) => (
        <span style={getStarStyle(rating - i)} key={i}>
          ⭐️
        </span>
      ))}
    </div>
  )
}

export default RatingStars
